var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "renwuquerenverify" }, [
    _c("div", { staticClass: "customer-phone" }, [
      _vm._v("\n    " + _vm._s(_vm.$route.query.phone) + "\n  "),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "input-verify" }, [
      _c("canvas", { attrs: { id: "canvas" }, on: { click: _vm.initCavans } }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.verify,
            expression: "verify",
          },
        ],
        attrs: { type: "text", placeholder: "请输入图形验证码" },
        domProps: { value: _vm.verify },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.verify = $event.target.value
          },
        },
      }),
    ]),
    _vm._v(" "),
    !_vm.noLogin
      ? _c("div", { staticClass: "input-captcha" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.captcha,
                expression: "captcha",
              },
            ],
            attrs: { type: "text", placeholder: "请输入验证码" },
            domProps: { value: _vm.captcha },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.captcha = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              class: ["btn-captcha", { disable: _vm.isTimerStart }],
              on: { click: _vm.getCaptcha },
            },
            [_vm._v(_vm._s(_vm.isTimerStart ? this.count + "s" : "获取验证码"))]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("span", { class: ["btn-login"], on: { click: _vm.gotoDetail } }, [
      _vm._v("确认看房"),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }